import { useEffect } from "react";

import { fetchPrescriptionsRenewalCounters } from "../Api/PrescriptionRenewalsClient";
import { PrescriptionRenewalsRoutes } from "./PrescriptionRenewalsRoutes";

import styles from "./PrescriptionRenewalsTab.module.scss";

function PrescriptionRenewalsTab(): JSX.Element {
    useEffect(() => {
        fetchPrescriptionsRenewalCounters();
    }, []);

    return (
        <div className={styles.container}>
            <PrescriptionRenewalsRoutes />
        </div>
    );
}

export { PrescriptionRenewalsTab };
